import NameStep from "./NameStep";
import PhotoStep from "./PhotoStep";
import QuestionStep from "./QuestionStep";

const steps = {
  name: NameStep,
  photo: PhotoStep,
  question: QuestionStep,
};

export const getStepComponent = (type) => steps[type] || null;

export default steps;
